import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import importImages from '../../../util/webpack';

// require.context requires that you use no variables and only constants as arguments
const footerImages = importImages(require.context('../../../../public/images/footer/', false, /\.(jpg|jpeg|png|gif|svg)(\?.*)?$/));

class MainFooter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isIos: navigator.userAgent.match(/iP(hone|od|ad)/i),
      isAndroid: navigator.userAgent.match(/Android/i)
    };
  }

  render() {
    const { userContext } = this.props;
    const inspirationLink = (userContext.is_inspiration_vendor) ? '/inspiration/manage/listings' : '/inspiration/become-a-vendor';

    return (
      <footer id="zola-footer" className="zola-footer">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-3 col-sm-push-9">
              <div className="row mobile-apps">
                <h3 className="hidden-xs col-sm-12">Download the <br className="visible-sm" />Zola App</h3>
                <a className={`footer-ios col-sm-12${this.state.isIos ? ' col-xs-12' : ''}${this.state.isAndroid ? ' hidden-xs' : ''}${!this.state.isIos && !this.state.isAndroid ? ' col-xs-6' : ''}`} href="https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916" target="_blank" rel="noopener noreferrer">
                  <img src={footerImages('appStoreBadge')} alt="Zola iOS App" />
                </a>
                <a className={`footer-android col-sm-12${this.state.isIos ? ' hidden-xs' : ''}${this.state.isAndroid ? ' col-xs-12' : ''}${!this.state.isIos && !this.state.isAndroid ? ' col-xs-6' : ''}`} href="https://play.google.com/store/apps/details?id=com.zola.android.wedding&hl=en" target="_blank" rel="noopener noreferrer">
                  <img src={footerImages('googlePlayBadge')} alt="Zola Android App" />
                </a>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-sm-push-2">
              <div className="row help-about">
                <div className="col-xs-6">
                  <h3 className="hidden-xs">About Zola</h3>
                  <ul className="list-unstyled">
                    <li><a href="/about/index">Our Story</a></li>
                    <li><a href="/about/press">Press</a></li>
                    <li><a href="/about/jobs">Jobs</a></li>
                    <li><a href="https://www.zola.com/blog" target="_blank" rel="noopener noreferrer">Blog</a></li>
                    <li><a href="/townhouse">Zola Townhouse</a></li>
                    <li><a href={inspirationLink}>Wedding Vendors</a></li>
                    <li><a href="/wedding/credits" target="_blank" rel="noopener noreferrer">Art Credits</a></li>
                  </ul>
                </div>
                <div className="col-xs-6">
                  <h3 className="hidden-xs">Help</h3>
                  <ul className="list-unstyled">
                    <li><a href="/search/wedding-registry">Find a Couple</a></li>
                    <li><a href="https://help.zola.com/hc" target="_blank" rel="noopener noreferrer">FAQs</a></li>
                    <li><a href="/order-status">Order Status</a></li>
                    <li><a href="/returns">Return Policy</a></li>
                    <li><a href="mailto:support@zola.com" target="_self">support@zola.com</a></li>
                    <li className="phone">1-408-657-ZOLA</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-5 col-sm-pull-7">
              <div className="social-and-terms">
                <div className="hidden-xs">
                  <div className="zola-logo-minimal-100" />
                  <div className="tagline">The wedding company that&#39;ll do anything for love.</div>
                </div>
                <ul className="list-unstyled list-inline">
                  <li><a href="https://www.facebook.com/zola" target="_blank" rel="noopener noreferrer"><i className="zolaicon zolaicon-facebook" /></a></li>
                  <li><a href="https://pinterest.com/zola" target="_blank" rel="noopener noreferrer"><i className="zolaicon zolaicon-pinterest-circled" /></a></li>
                  <li><a href="https://twitter.com/zola" target="_blank" rel="noopener noreferrer"><i className="zolaicon zolaicon-twitter" /></a></li>
                  <li><a href="https://instagram.com/zola" target="_blank" rel="noopener noreferrer"><i className="zolaicon zolaicon-instagram" /></a></li>
                </ul>
                <div className="hashtag">@ZOLA | #ANYTHINGFORLOVE</div>
                <div className="clearfix" />
                <div>
                  <small>
                    &copy; 2018 Zola, Inc. All rights reserved.
                    <br />
                    <span><a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> / </span>
                    <span><a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a></span>
                    <span className="hidden-xs hidden-sm"> / </span><br className="visible-xs visible-sm" />
                    <span><a href="/webaccessibility" target="_self">Web Accessibility</a> / </span>
                    <span><a href="/privacy#CA-privacy-rights" target="_blank" rel="noopener noreferrer" >Your CA Privacy Rights</a></span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

MainFooter.defaultProps = {
  userContext: {
    isInspirationVendor: false
  }
};

MainFooter.propTypes = {
  userContext: PropTypes.shape({
    is_inspiration_vendor: PropTypes.bool,
  }).isRequired
};

const mapStateToProps = state => ({
  userContext: state.user.userContext
});

export default connect(
  mapStateToProps
)(MainFooter);



/** WEBPACK FOOTER **
 ** ./src/components/common/footer/MainFooter.jsx
 **/